import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import apps from './routes/apps'
import dashboard from './routes/dashboard'
import properties from './routes/properties'
import places from './routes/places'
import poi from './routes/poi'
import blogs from './routes/blogs'
import users from './routes/users'
import enquiry from './routes/enquiry'
import uiElements from './routes/ui-elements/index'
import pages from './routes/pages'
import chartsMaps from './routes/charts-maps'
import formsTable from './routes/forms-tables'
import others from './routes/others'
import settings from './routes/settings'
import closedeail from './routes/close-deals'
import GroupEmail from './routes/group-email'
import crm from './routes/crm'
import phonebook from './routes/phonebook'
import matched from './routes/matched'
import files from './routes/files'
import inventoryList from './routes/inventory-list'
import InventoryListDocument from '../views/inventory-list/pdf-form/InventoryListDocument.vue'
import languages from './routes/languages'
import housePin from './routes/house-pin'
import house from './routes/house'
import aiBot from './routes/ai-bot'
import mailLog from './routes/mail-log'
import aiUsage from './routes/ai-usage'
import analyticsReport from './routes/analytics'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.path === from.path) return false
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'dashboard-fbr' } },
    ...apps,
    ...dashboard,
    ...properties,
    ...places,
    ...poi,
    ...blogs,
    ...users,
    ...enquiry,
    ...pages,
    ...chartsMaps,
    ...formsTable,
    ...uiElements,
    ...others,
    ...settings,
    ...closedeail,
    ...GroupEmail,
    ...crm,
    ...phonebook,
    ...matched,
    ...files,
    ...inventoryList,
    ...languages,
    ...housePin,
    ...house,
    ...aiBot,
    ...mailLog,
    ...aiUsage,
    ...analyticsReport,
    {
      path: '*',
      redirect: 'error-404',
    },
    {
      path: '/inventory-report',
      name: 'InventoryListDocument',
      component: InventoryListDocument,
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
